import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminDomains() {
	const [domains, setDomains] = useState([]);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		async function load() {
			try {
				const res = await fetch('/api/admin/domains', { credentials: 'include' });
				if (!res.ok) throw new Error('load failed');
				const data = await res.json();
				const list = Array.isArray(data) ? data : (data.data || []);
				setDomains(list);
			} catch (e) {
				console.error(e);
			} finally {
				setLoading(false);
			}
		}
		load();
	}, []);

	if (loading) return <div className="p-8 text-white">Загрузка...</div>;

	return (
		<div className="p-8 text-white max-w-7xl mx-auto">
			<h1 className="text-3xl font-bold mb-6">Сайты пользователей</h1>
			<div className="overflow-x-auto rounded-2xl border border-white/10">
				<table className="w-full text-sm">
					<thead className="bg-white/5 text-gray-300">
						<tr>
							<th className="text-left p-3">Домен</th>
							<th className="text-left p-3">Пользователь</th>
							<th className="text-left p-3">Backend IP</th>
							<th className="text-left p-3">Подключён</th>
							<th className="text-left p-3">Прикреплён (DNS)</th>
							<th className="text-left p-3">Боты</th>
							<th className="text-left p-3">Сертификат до</th>
							<th className="text-left p-3"></th>
						</tr>
					</thead>
					<tbody>
						{domains.map(d => (
							<tr key={d.id} className="border-t border-white/10">
								<td className="p-3">{d.domain}</td>
								<td className="p-3 text-gray-400">{d.user_email || d.user_id}</td>
								<td className="p-3">{d.backendIP}</td>
								<td className="p-3">{d.verified ? 'да' : 'ожидает'}{d.active ? '' : ' (выкл)'}</td>
								<td className="p-3">
									<span
										className={`inline-block w-3 h-3 rounded-full ${d.attached ? 'bg-green-500' : 'bg-red-500'}`}
										title={d.attached ? 'Домен прикреплён к системе' : 'Домен не прикреплён к системе'}
									/>
								</td>
								<td className="p-3">{d.bots_enabled ? 'включена' : 'выкл'}</td>
								<td className="p-3">{d.cert_not_after ? new Date(d.cert_not_after).toLocaleDateString() : 'n/a'}</td>
								<td className="p-3">
									<button
										onClick={() => navigate(`/dashboard?domain=${d.id}`)}
										className="px-3 py-1 rounded-lg bg-blue-600 hover:bg-blue-700 transition"
									>
										Статистика
									</button>
								</td>
							</tr>
						))}
						{domains.length === 0 && (
							<tr><td colSpan="8" className="p-4 text-gray-400">Сайтов нет</td></tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
}
